<template>
    <transition
        appear
        name="fade"
        :enter-active-class="theme.fadeEnterActive"
        :enter-class="theme.fadeEnter"
        :enter-to-class="theme.fadeEnterTo"
        :leave-active-class="theme.fadeLeaveActive"
        :leave-class="theme.fadeLeave"
        :leave-to-class="theme.fadeLeaveTo"
    >
        <div v-if="active" :class="theme.wrapper" @click="handleClose">
            <date-picker-raw
                @mouseleave.native="handleBlur"
                @mouseenter.native="handleFocus"
                v-model="cacheValue"
                :value="value"
                :format="format"
            >
                <v-button flat primary @click="$emit('close')" v-margin.right="2">
                    отмена
                </v-button>

                <v-button flat primary @click="handleSelect">
                    ок
                </v-button>
            </date-picker-raw>
        </div>
    </transition>
</template>

<script>
    import { Margin } from '../../directives';
    import { vButton } from '../Button';
    import DatePickerRaw from './DatePickerRaw.vue';
    import theme from './datePicker.scss';

    export default {
        name: 'date-picker',
        props: {
            active: Boolean,
            value: String,
            format: String,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        components: {
            DatePickerRaw,
            vButton,
        },
        directies: {
            Margin
        },
        data() {
            return {
                isOver: false,
                cacheValue: this.value,
            }
        },
        methods: {
            handleClose() {
                if (!this.isOver) {
                    this.$emit('close');
                }
            },
            handleFocus() {
                this.isOver = true;
            },
            handleBlur() {
                this.isOver = false;
            },
            handleSelect() {
                this.$emit('input', this.cacheValue);
                this.$emit('close');
            }
        },
    }
</script>


// WEBPACK FOOTER //
// DatePicker.vue?56069abd